// Frontend/src/api/room.ts
import { APINodeClient } from './apiNodeCore';

const api = new APINodeClient();

// Fetch room options from the backend
export const fetchRoomOptionsApi = async () => {
  return api.get('/api/rooms');
};

// Fetch booking details for a given room number
export const fetchBookingDetailsApi = async (roomNumber: string) => {
  return api.create('/api/booking-details',{roomNumber:roomNumber});
};



// export const approvedEntrySubmitApi = async (data: any) => {
//   return api.create('/api/approve-entry',data);
// };

